// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbz_a bii_i bii_j","ColorVariants__color":"bbz_b bii_rp","ColorVariants__more":"bbz_c bii_vv"};